<template>
<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g>
	<g>
		<path d="M384.376,474.589c-4.141-0.514-7.909,2.428-8.423,6.569c-1.108,8.967-8.766,15.728-17.824,15.728H62.006
			c-9.904,0-17.965-8.05-17.965-17.965V172.995L85.14,308.492c0.987,3.264,3.99,5.37,7.224,5.37c0.725,0,1.471-0.111,2.196-0.332
			c4-1.209,6.257-5.431,5.038-9.421L61.895,179.796c5.139,12.786,17.673,21.844,32.292,21.844c19.184,0,34.801-15.617,34.801-34.801
			c0-13.425,0-76.422,0-86.802c50.353-15.282,110.824-33.615,166.853-50.61c3.99-1.219,6.247-5.431,5.038-9.431
			c-1.219-3.99-5.441-6.247-9.431-5.038l-139.8,42.408c-8.071-15.819-24.524-26.67-43.476-26.67
			c-26.902,0-48.786,21.884-48.786,48.786v5.874l-6.751,2.045C38.59,91.654,29.159,104.37,29.159,119.04l-0.232,8.947v350.935
			c0,18.247,14.841,33.078,33.078,33.078h296.123c16.675,0,30.781-12.464,32.826-28.988
			C391.471,478.871,388.518,475.093,384.376,474.589z M74.501,79.483c0-18.569,15.103-33.673,33.673-33.673
			c12.111,0,22.751,6.428,28.675,16.051l-13.038,3.95c-11.983-13.784-34.747-6.934-37.008,11.224
			c-0.266,2.084-0.173,74.826-0.171,77.613c0,4.171,3.385,7.557,7.557,7.557s7.557-3.385,7.557-7.557c0-5.565,0-71.669,0-74.973
			c0-3.345,2.72-6.066,6.066-6.066s6.066,2.72,6.066,6.066c0,10.357,0,75.641,0,87.164c0,10.851-8.836,19.688-19.688,19.688
			c-10.852,0-19.688-8.836-19.688-19.688C74.501,148.187,74.501,98.358,74.501,79.483z M49.533,106.395
			c0.01-0.02,0.02-0.03,0.03-0.02c0.689-0.471,4.008-3.921,9.824-4.746c0.245,67.909-0.553,66.116,0.725,72.293L45.05,124.269
			C43.057,117.627,45.039,110.917,49.533,106.395z"/>
	</g>
</g>
<g>
	<g>
		<path d="M377.263,23.492C371.804,5.5,353.058-3.776,336.013,1.447l-15.637,4.736c-3.99,1.219-6.247,5.431-5.038,9.431
			c1.209,3.99,5.431,6.247,9.421,5.038c14.819-4.283,16.446-5.521,20.867-5.521c7.829,0,14.902,5.239,17.179,12.756l21.713,71.598
			l6.69,22.046l75.95,250.4c2.968,9.704-2.782,19.621-11.97,22.408c-302.701,91.816-284.543,86.731-288.597,86.731
			c-7.839,0-14.902-5.239-17.179-12.756l-41.038-135.286c-1.209-3.99-5.431-6.247-9.421-5.038c-4,1.219-6.247,5.441-5.038,9.431
			l41.028,135.286c4.262,14.045,16.977,23.476,31.648,23.476c3.244,0,6.479-0.484,9.612-1.431l199.891-60.635v17.753
			c0,4.171,3.375,7.557,7.557,7.557c4.171,0,7.557-3.385,7.557-7.557v-22.338l68.363-20.736
			c14.045-4.262,23.486-16.977,23.486-31.638C483.057,367.962,486.784,386.258,377.263,23.492z"/>
	</g>
</g>
<g>
	<g>
		<path d="M258.033,183.782c-6.388-21.061-23.284-22.067-33.378-22.666c-9.115-0.668-15.45-0.249-17.513-7.053
			c-1.981-6.531,2.619-9.908,9.164-11.894c9.573-2.904,12.902,0.88,17.502-0.516c5.41-1.641,6.73-8.063,5.573-11.874
			c-2.461-8.114-14.834-7.278-21.462-6.198l-0.921-3.038c-1.516-4.999-6.816-7.832-11.815-6.316
			c-4.999,1.516-7.832,6.816-6.315,11.816l1.266,4.172c-10.552,6.939-14.283,17.476-10.509,29.919
			c5.437,17.924,19.723,18.853,31.202,19.599c11.45,0.744,17.069,1.484,19.689,10.121c2.253,7.428-0.561,12.06-8.855,14.575
			c-13.364,4.053-15.371-5.807-22.659-3.596c-4.798,1.455-6.999,7.597-5.691,11.91c2.146,7.076,13.08,11.55,25.056,10.556
			l0.914,3.012c1.516,4.999,6.816,7.832,11.816,6.315c4.999-1.516,7.832-6.816,6.315-11.816l-0.974-3.212
			C258.222,210.523,262.448,198.338,258.033,183.782z"/>
	</g>
</g>
<g>
	<g>
		<path d="M374.142,223.441c-1.211-3.994-5.434-6.248-9.425-5.038l-215.418,65.343c-3.993,1.212-6.249,5.432-5.038,9.425
			c1.206,3.975,5.411,6.254,9.425,5.038l215.418-65.343C373.098,231.653,375.354,227.434,374.142,223.441z"/>
	</g>
</g>
<g>
	<g>
		<path d="M386.725,264.905c-1.22-3.99-5.442-6.247-9.431-5.038l-1.199,0.363l-214.218,64.978c-3.99,1.219-6.247,5.431-5.038,9.431
			c1.216,4.007,5.458,6.236,9.431,5.038c0.118-0.035,214.982-65.209,215.417-65.341
			C385.677,273.116,387.934,268.895,386.725,264.905z"/>
	</g>
</g>
<g>
	<g>
		<path d="M399.299,306.366c-1.19-3.912-5.323-6.249-9.421-5.038l-13.783,4.181l-201.644,61.169
			c-8.28,2.509-6.448,14.791,2.196,14.791c0.725,0,1.461-0.111,2.196-0.332c47.953-14.545,164.508-49.899,215.417-65.341
			C398.251,314.588,400.508,310.366,399.299,306.366z"/>
	</g>
</g>
<g>
	<g>
		<path d="M411.874,347.838c-1.209-3.99-5.431-6.247-9.421-5.038l-11.244,3.416c-190.462,57.767-203.516,61.725-204.153,61.919
			c-0.002,0-0.003,0.001-0.005,0.001c0.001,0,0.002-0.001,0.003-0.001c-0.007,0.002-0.013,0.004-0.017,0.005
			c0.001,0,0.002-0.001,0.003-0.001c-0.002,0-0.003,0.001-0.004,0.001c-8.297,2.509-6.442,14.792,2.186,14.792
			c1.702,0-10.959,3.701,217.614-65.673C410.836,356.049,413.093,351.827,411.874,347.838z"/>
	</g>
</g>
<g>
	<g>
		<path d="M187.054,408.135h0.002c0.012-0.005,0.019-0.007,0.02-0.007C187.073,408.129,187.064,408.132,187.054,408.135z"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
</template>
